import React from 'react'
import {Menu} from 'antd'
import {Link} from 'dva/router'
import menu from '../../utils/menu'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const topMenus = menu.map(item => item.key)
const getMenus = function (menuArray, sidebarCollapse, parentPath) {
    parentPath = parentPath || '/'

    return menuArray.map(item => {
        if (item.child) {
            return (
                <Menu.SubMenu
                    key={item.key}
                    title={
                        <span><span style={{marginRight: '5px'}}>{item.icon ? <Icon name={item.icon} /> : ''}</span>
                        {sidebarCollapse && topMenus.indexOf(item.key) >= 0 ? '' : item.name} </span>
                    }>

                    {getMenus(item.child, sidebarCollapse, parentPath + item.key + '/')}
                </Menu.SubMenu>
            )
        } else {
            return (
                <Menu.Item key={item.key}>
                    <Link to={parentPath + item.key}>
                        <span style={{marginRight: '5px'}}>{item.icon ? <Icon name={item.icon}/> : ''}</span>
                        {sidebarCollapse && topMenus.indexOf(item.key) >= 0 ? '' : item.name}
                    </Link>
                </Menu.Item>
            )
        }
    })
}

function Menus({sidebarCollapse, navOpenKeys, changeOpenKeys}) {

    // Se oculta o muestra elementos del menú según el usuario logueado
    let menu_items = [...menu];
    if (localStorage.getItem('currentHotel')) {
        //menu_items = _.without(menu_items, _.find(menu_items, {key: 'hotels'}));
        //menu_items = _.without(menu_items, _.find(menu_items, {key: 'users'}));

        /*const invoice_menu = _.find(menu_items, {key: 'invoices'})
        invoice_menu.child = _.without(invoice_menu.child, _.find(invoice_menu.child, {key: 'list-invoices'}));*/
    }

    if (JSON.parse(localStorage.getItem('currentUser')).type === 'gerente') {
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'hotels'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'all_users'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'employees'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'conta/trie'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'config'}));
    }

    if (JSON.parse(localStorage.getItem('currentUser')).type === 'recepcionista') {
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'hotels'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'all_users'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'employees'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'catalogs'}))
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'incomes'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'conta/hotel'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'conta/trie'}));
        menu_items = _.without(menu_items, _.find(menu_items, {key: 'config'}));
    }
    
    const menuItems = getMenus(menu_items, sidebarCollapse)

    // Función que abre un submenú y cierra los demás
    const onOpenChange = (openKeys) => {
        const latestOpenKey = openKeys.find(key => !(navOpenKeys.indexOf(key) > -1))
        const latestCloseKey = navOpenKeys.find(key => !(openKeys.indexOf(key) > -1))
        let nextOpenKeys = []

        if (latestOpenKey) nextOpenKeys = getAncestorKeys(latestOpenKey).concat(latestOpenKey)
        if (latestCloseKey) nextOpenKeys = getAncestorKeys(latestCloseKey)

        changeOpenKeys(nextOpenKeys)
    }
    
    const getAncestorKeys = (key) => {
        const map = {
            navigation2: ['navigation']
        }
        return map[key] || []
    }
      
    // Cuando el sidebar esté collapsada, no se puede desplegar como acordion los submenús
    let menuProps = !sidebarCollapse
    ? { onOpenChange, openKeys: navOpenKeys }
    : {}

    return (
        <div>
            <Menu
                {...menuProps}
                mode={sidebarCollapse ? 'vertical' : 'inline'} >
                {menuItems}
            </Menu>
        </div>
    )
}

export default Menus


// WEBPACK FOOTER //
// ./src/components/layout/menu.js